import { AlertCircle } from "lucide-react";

import { CopyButton } from "@/components/ui/copy-button";
import { cn } from "@/lib/utils";

interface ScorecardCopyableErrorProps {
  message: string;
  title?: string;
  className?: string;
  compact?: boolean;
}

const ScorecardCopyableError = ({
  message,
  title = "Execution error",
  className,
  compact = false,
}: ScorecardCopyableErrorProps) => (
  <div
    className={cn(
      "rounded-md border border-red-200 bg-red-50 text-red-800",
      compact ? "px-2 py-1.5 text-xs" : "px-3 py-2 text-sm",
      className,
    )}
  >
    <div className="flex items-start gap-1.5">
      <AlertCircle className={cn("mt-0.5 shrink-0", compact ? "h-3 w-3" : "h-4 w-4")} />
      <div className="min-w-0 flex-1 space-y-1">
        <div className="flex items-start justify-between gap-2">
          <div className="font-medium text-red-900">{title}</div>
          <CopyButton
            text={message}
            title="Copy error"
            iconSize="h-3.5 w-3.5"
            className="h-6 w-6 shrink-0 text-red-700 hover:bg-red-100 hover:text-red-900"
          />
        </div>
        <p className="select-text whitespace-pre-wrap break-words leading-relaxed text-red-800">
          {message}
        </p>
      </div>
    </div>
  </div>
);

export default ScorecardCopyableError;
